<script setup>
import { inject, computed } from 'vue';
import { useProductsStore } from '@/app/stores/productsStore.js';
const config = inject('config');
const gaPush = inject('gaPush');
const productsStore = useProductsStore();

const tags = computed(() => productsStore.dynamicFiltersArr.filter((filter, i) => filter.selected));

function handleClearAll() {
  handleFilterRemoveAllGa();
  productsStore.resetDynamicFiltersArr();
}

function handleRemoveOne(tag) {
  productsStore.removeOneFilter(tag.id);
  handleFilterRemoveGa(tag);
}

function handleFilterRemoveGa(tag) {
  const gaPayload = {
    event: 'prod_spec_remove_filter',
    filter_name: tag.name,
    filter_value: productsStore.selectedOption(productsStore.options(tag)).label,
    product_category: config.category,
    measurement_system: productsStore.system || null,
  };
  gaPush(gaPayload);
}

function handleFilterRemoveAllGa() {
  const gaPayload = {
    event: 'prod_spec_clear_filters',
    selected_filters: productsStore.selectedFiltersListString,
    product_category: config.category,
    measurement_system: productsStore.system || null,
  };
  gaPush(gaPayload);
}
</script>

<template>
  <div
    class="c-product-listing-filter-tags"
    :class="{ 'mobile-hide': productsStore.hideFilterMobile }"
  >
    <h2 class="c-product-listing-filter-tags__title">{{ config.filterByLabel }}</h2>
    <ul class="c-product-listing-filter-tags__list" role="list">
      <li
        v-for="(tag, i) in tags"
        :key="`${tag.id}-selected`"
        class="c-product-listing-filter-tags__list-item"
        role="listitem"
      >
        <span class="sr-only">{{ tag.name }}</span>
        <button
          class="c-product-listing-filter-tags__tag"
          :aria-label="`Remove ${tag.name} from the list`"
          @click="handleRemoveOne(tag)"
        >
          {{ tag.name }}
        </button>
      </li>
      <li>
        <button
          v-if="tags.length"
          class="c-product-listing-filter-tags__clear"
          @click="handleClearAll"
        >
          {{ config.clearAll }}
        </button>
      </li>
    </ul>
  </div>
</template>